import SvgIcon from '@mui/material/SvgIcon'

const ContextIcon = ({ color = "rgba(0,0,0,0.54)" }: {color?: string}) => {
  return (
      <SvgIcon htmlColor={ color }>
        <path d="M21 1v0h-18v22h18zM9 22v-3h6v3zM5 5v-2h2v2zM9 5v-2h2v2zM13 5v-2h2v2zM17 5v-2h2v2z
            M7 21h-2v-2h2v2zM7 17h-2v-2h2v2zM7 13h-2v-2h2v2zM11 17h-2v-2h2v2zM11 13h-2v-2h2v2z
            M11 9h-2v-2h2v2zM15 17h-2v-2h2v2zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM19 21h-2v-2h2v2z
            M19 17h-2v-2h2v2zM7 9h-2v-2h2v2zM19 9h-2v-2h2v2zM19 13h-2v-2h2v2z"></path>
    </SvgIcon>
  )
}

export default ContextIcon
